import { forwardRef } from 'react'

import { RecapBanner } from 'components/meetings/RecapBanner'
import { useNotetakerState, NotetakerDisplayMode } from 'features/meetings/hooks'
import { AiRecapButton } from 'features/meetings/meeting_detail/header/ai_recap_button'

import { NotetakerToggle } from '../notetaker_toggle'

interface NotetakerControlProps {
  event: any
  hasSpotlight?: boolean
  trackFromContactPage?: boolean
}

/**
 * Unified router component for notetaker toggle and recap UI states.
 * Routes to appropriate child component based on displayMode from useNotetakerState.
 * @param event - Meeting event object
 * @param hasSpotlight - Whether meeting has spotlight for onboarding tour
 * @param trackFromContactPage - Whether to track analytics from contact page context
 */
export const NotetakerControl = forwardRef<HTMLDivElement | null, NotetakerControlProps>(({
  event,
  hasSpotlight,
  trackFromContactPage = false,
}, ref) => {
  const { displayMode, noRecapTooltipKey, toggleState } = useNotetakerState(event)

  switch (displayMode) {
    case NotetakerDisplayMode.HIDDEN:
      return null

    case NotetakerDisplayMode.TOGGLE_ON:
    case NotetakerDisplayMode.TOGGLE_OFF:
      return (
        <NotetakerToggle
          ref={ref}
          event={event}
          hasSpotlight={hasSpotlight}
          trackFromContactPage={trackFromContactPage}
          toggleState={toggleState}
        />
      )

    case NotetakerDisplayMode.RECAP_PROCESSING:
      return <RecapBanner variant="processing" event={event} />

    case NotetakerDisplayMode.NO_RECAP_AVAILABLE:
      return <RecapBanner variant="no-recap" tooltipKey={noRecapTooltipKey!} event={event} />

    case NotetakerDisplayMode.RECAP_BUTTON:
      return <AiRecapButton event={event} location="meetings_page" />

    case NotetakerDisplayMode.RECAP_ERROR:
      return <RecapBanner variant="error" event={event} />

    default:
      return null
  }
})
